/* CsPager: the standard pagination control.

   Previous / Next, "Page 2 of 14", the row range ("21-40 of 261") and a
   rows-per-page choice that starts at 20. It knows nothing about Frappe or about
   any one page: give it a container and the numbers, and it calls back when the
   person moves. The Desk lists use it (cs_desk.bundle.js) and so can any portal
   page with a long table.

     var pager = new CsPager(document.getElementById("pager"), {
       total: 261,                    // all rows, not just this page
       storageKey: "my-table-size",   // remember the rows-per-page choice
       onChange: function (s) { load(s.start, s.pageSize); }  // s.page, s.pageSize, s.start
     });
     pager.set({ total: 40 });        // after the data or filters change
     pager.set({ page: 1 });          // jump to a page without calling onChange
*/
(function () {
  var DEFAULT_SIZES = [20, 50, 100, 500];

  function t(text) {
    return typeof window.__ === "function" ? window.__(text) : text;
  }

  function storedSize(key, sizes, fallback) {
    try {
      var v = parseInt(window.localStorage.getItem(key), 10);
      if (sizes.indexOf(v) !== -1) return v;
    } catch (e) {}
    return fallback;
  }

  function number(n) {
    try {
      return Number(n).toLocaleString();
    } catch (e) {
      return String(n);
    }
  }

  function CsPager(container, options) {
    options = options || {};
    this.el = container;
    this.sizes = options.sizes || DEFAULT_SIZES;
    this.storageKey = options.storageKey || "cs-pager-size";
    this.onChange = options.onChange || function () {};
    this.total = Math.max(0, options.total || 0);
    this.pageSize = options.pageSize || storedSize(this.storageKey, this.sizes, this.sizes[0]);
    this.page = Math.max(1, options.page || 1);
    this.build();
    this.draw();
  }

  CsPager.prototype.build = function () {
    var me = this;
    var sizeOptions = this.sizes
      .map(function (n) {
        return '<option value="' + n + '">' + n + "</option>";
      })
      .join("");
    this.el.classList.add("cs-pager");
    this.el.innerHTML =
      '<div class="cs-pager-range" aria-live="polite"></div>' +
      '<div class="cs-pager-ctrl">' +
      '<label class="cs-pager-size">' + t("Rows") + ' <select aria-label="' + t("Rows per page") + '">' + sizeOptions + "</select></label>" +
      '<button type="button" class="btn btn-default btn-sm cs-pager-prev">' + t("Previous") + "</button>" +
      '<span class="cs-pager-page"></span>' +
      '<button type="button" class="btn btn-default btn-sm cs-pager-next">' + t("Next") + "</button>" +
      "</div>";
    this.$range = this.el.querySelector(".cs-pager-range");
    this.$page = this.el.querySelector(".cs-pager-page");
    this.$prev = this.el.querySelector(".cs-pager-prev");
    this.$next = this.el.querySelector(".cs-pager-next");
    this.$size = this.el.querySelector("select");

    this.$prev.addEventListener("click", function () {
      me.go(me.page - 1);
    });
    this.$next.addEventListener("click", function () {
      me.go(me.page + 1);
    });
    this.$size.addEventListener("change", function () {
      var n = parseInt(me.$size.value, 10) || me.sizes[0];
      try {
        window.localStorage.setItem(me.storageKey, String(n));
      } catch (e) {}
      me.pageSize = n;
      me.page = 1;
      me.draw();
      me.fire();
    });
  };

  CsPager.prototype.pages = function () {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  };

  CsPager.prototype.state = function () {
    return { page: this.page, pageSize: this.pageSize, start: (this.page - 1) * this.pageSize, total: this.total };
  };

  CsPager.prototype.fire = function () {
    this.onChange(this.state());
  };

  CsPager.prototype.go = function (page) {
    page = Math.min(this.pages(), Math.max(1, page));
    if (page === this.page) return;
    this.page = page;
    this.draw();
    this.fire();
  };

  /* Update the numbers from outside. Does not call onChange. */
  CsPager.prototype.set = function (values) {
    values = values || {};
    if (values.total !== undefined) this.total = Math.max(0, values.total || 0);
    if (values.pageSize) this.pageSize = values.pageSize;
    if (values.page) this.page = Math.max(1, values.page);
    this.page = Math.min(this.page, this.pages());
    this.draw();
  };

  CsPager.prototype.draw = function () {
    var pages = this.pages();
    var from = this.total ? (this.page - 1) * this.pageSize + 1 : 0;
    var to = Math.min(this.total, this.page * this.pageSize);
    this.$range.textContent = this.total ? from + "–" + to + " " + t("of") + " " + number(this.total) : "";
    this.$page.textContent = t("Page") + " " + this.page + " " + t("of") + " " + pages;
    this.$prev.disabled = this.page <= 1;
    this.$next.disabled = this.page >= pages;
    this.$size.value = String(this.pageSize);
    // Nothing to page through, and the smallest size already shows it all.
    this.el.classList.toggle("is-single", this.total <= this.sizes[0]);
  };

  CsPager.prototype.destroy = function () {
    this.el.innerHTML = "";
    this.el.classList.remove("cs-pager");
  };

  CsPager.DEFAULT_SIZES = DEFAULT_SIZES;
  CsPager.storedSize = storedSize;
  window.CsPager = CsPager;
})();
